import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import PrimaryBtn from 'src/Components/GlobalComponents/primaryBtn';
import SelectDropdown from 'src/Components/GlobalComponents/SelectDropdown';
import CustomWebsiteDropdown from 'src/Components/GlobalComponents/Widget/CustomWebsiteDropdown';
import SimpleInput from 'src/Components/SimpleInput';
import httpRequest from 'src/helpers/httpRequest';
import { IPharmaBrand, IPharmaInventoryCreate } from 'src/types/GlobalInterfaces';
import { Option } from 'react-multi-select-component';

interface IProps {
    state: IPharmaInventoryCreate;
    setState: (key: keyof IPharmaInventoryCreate, val: string) => void;
    tabChange: () => void;
    tooglePrescription: () => void;
};

const InventryGeneralTab: React.FC<IProps> = ({ state, setState, tabChange, tooglePrescription }) => {
    const [isLoader, setIsLoader] = useState<boolean>(false);
    const [allBrands, setAllBrands] = useState<{ value: string; label: string }[]>([]);
    const fetchAllBrands = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<{ documents: IPharmaBrand[] }>({ path: "/brand/getAllBrands" });
        if (res) {
            const arr = res?.documents?.map(v => ({ value: v?._id, label: v?.brandName })) || [];
            setAllBrands(arr);
        } else {
            toast(err, { type: "error" });
        }
        setIsLoader(false);
    };
    useEffect(() => {
        fetchAllBrands();
    }, []);

    const deliveryTime = [
        { value: "instant", label: "Instant Delivery" },
        { value: "standard", label: "Standard Delivery" },
    ]

    return (
        <>
            <div className='products-tabs-content'>
                <SimpleInput
                    value={state?.productName}
                    onChange={(val) => setState("productName", val)}
                    isLabel={true}
                    labelText="Product Name"
                    maxLength={100}
                    id="product-name-input"
                />

                <CustomWebsiteDropdown
                    options={allBrands}
                    data={allBrands.filter(v => v?.value === state?.brandId)}
                    setData={(e) => setState("brandId", e[0]?.value || "")}
                    labelText="Brand Name"
                    isRequired={true}
                    dropdownMainId="brand-dropdown"
                    clearId="brand-clear"
                    optionId={(v : Option , index) => `brand-option-${index + 1}`}
                    loading={isLoader}
                />

                <SimpleInput
                    min={1}
                    type="number"
                    value={state?.quantity}
                    onChange={(val) => setState("quantity", val)}
                    isLabel={true}
                    labelText="Quantity"
                    onKeyDown={(e: any) => {
                        if (["e", "E", "-", "+"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    id="quantity-input"
                    maxLength={10}
                />
                <CustomWebsiteDropdown
                    options={deliveryTime}
                    data={deliveryTime.filter(v => v?.value === state?.deliveryType)}
                    setData={(e) => setState("deliveryType", e[0]?.value || "")}
                    labelText="Delivery Type"
                    isRequired={true}
                    dropdownMainId="delivery-type-dropdown"
                    clearId="delivery-type-clear"
                    optionId={(v : Option , index) => `delivery-type-option-${index + 1}`}
                    loading={isLoader}
                />
                <SimpleInput
                    min={1}
                    type="text"
                    value={state?.sku}
                    onChange={(val) => setState("sku", val)}
                    isLabel={true}
                    labelText="SKU"
                    onKeyDown={(e: any) => {
                        if (["e", "E", "-", "+"].includes(e.key)) {
                            e.preventDefault();
                        }
                    }}
                    id="sku-input"
                    maxLength={10}
                />
                <div className="flex items-center gap-2">
                    <input
                        checked={state?.prescriptionRequired || false}
                        type="checkbox"
                        id="diagnostic-prescriped"
                        onChange={tooglePrescription}
                    />
                    <label htmlFor="diagnostic-prescriped" className="font-size-18px font-Poppins-Regular">Prescription Required</label>
                </div>
            </div>
            <div className='flex justify-end my-6'>
                <PrimaryBtn
                    ButtonText="Next"
                    btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
                    onPress={tabChange}
                    id="next-btn"
                />
            </div>
        </>
    );
};

export default InventryGeneralTab;